import { VariableOptionType } from "../enum/VariableOptionType";

/**
 * German labels for VariableOptionType (variable option / preset category).
 * Single source of truth for UI display (tables, dropdowns, etc.).
 */
export const VARIABLE_OPTION_TYPE_LABELS: Record<VariableOptionType, string> = {
  [VariableOptionType.HINGE_SET]: "Scharnier-Reihe",
  [VariableOptionType.LOCK_SET]: "Schloss-Reihe",
  [VariableOptionType.FEET]: "Fuß",
  [VariableOptionType.DISHES]: "Einbauschale",
  [VariableOptionType.HANDLES]: "Griff",
  [VariableOptionType.TROLLEY_HANDLES]: "Ausziehgriff",
  [VariableOptionType.ROLLER_BOARD]: "Rollbrett",
  [VariableOptionType.RUNNERS]: "Rutschleisten",
};

/** Preset category labels (VariableOptionType + COVER_PADDING). */
export const PRESET_CATEGORY_LABELS: Record<string, string> = {
  ...VARIABLE_OPTION_TYPE_LABELS,
  COVER_PADDING: "Deckelpolsterung",
};

/**
 * Returns the German label for a preset category (VariableOptionType or "COVER_PADDING").
 * Falls back to the raw value or "—" if unknown.
 */
export function getPresetCategoryLabel(category: string | undefined): string {
  if (category == null || category === "") return "—";
  return PRESET_CATEGORY_LABELS[category] ?? category;
}
